import dictionaryListSaga from 'modules/Dictionary/saga/list';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* dictionarySaga(): SagaIterator {
  yield fork(dictionaryListSaga);
}
